import React from 'react';
import designTokens from '@/design-tokens';
import Toast from './Toast';
import { useToast } from './ToastContext';
import './ToastAnimations.css';

const ToastContainer: React.FC = () => {
  const { toasts, hideToast } = useToast();

  const containerStyle: React.CSSProperties = {
    position: 'fixed',
    top: '64px', // Start right below TopNav (64px height)
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 999999, // Higher than modals (99999) to ensure toasts appear on top
    pointerEvents: 'none',
    width: 'calc(100vw - 32px)',
    maxWidth: '600px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  };

  const toastWrapperStyle: React.CSSProperties = {
    pointerEvents: 'auto',
    marginBottom: '16px',
  };

  return (
    <div style={containerStyle}>
      {toasts.map((toast) => (
        <div 
          key={toast.id} 
          className={`toast-animation ${toast.isExiting ? 'toast-exit' : ''}`}
          style={toastWrapperStyle}
        >
          <Toast
            status={toast.status}
            message={toast.message}
            details={toast.details}
            cta={toast.cta}
            onClose={() => hideToast(toast.id)}
          />
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;